import api from "../config/api";

import useAuth from "./useAuth";

const useLogout = () => {
  const { setAuth } = useAuth();

  const logout = async (callback) => {
    try {
      await api.get("/auth/customer/logout");

      setAuth({});

      callback && callback();
    } catch (err) {
      throw new Error(err);
    }
  };

  return logout;
};

export default useLogout;
